import axios from 'axios';
import * as actions from '../actions/actions';
import {BASE_URL} from '../../common/url';
import { Util } from '../../common/util';
import { Modal } from 'antd';
import Observer from '../stores/observer';

let showModel = true ;

class Server {
    
    /**
     * 登录轮询 - gcrp
     */
    gcrpScanPolling(params) {
        axios({
            url: '/webGcrpManage/scanPolling',
            baseURL: BASE_URL,
            method: 'post',
            data: params
        }).then(function (response) {
            actions.dispatcherActions(response.data, '_scanPolling');
        })
    }

    /**
     * 账号密码登录 - gcrp
     */
    gcrpPasswordLogin(params) {
        axios({
            url: '/webGcrpManage/passwordLogin',
            baseURL: BASE_URL,
            method: 'post',
            data: params
        }).then(function (response) {
            actions.dispatcherActions(response.data, '_passwordLogin');
        }).catch(function () {
            actions.dispatcherActions({ errCode: -1, errMsg: '网络异常，请稍后重试' }, '_passwordLogin');
        })
    }

    /**
     * 登录轮询 - crp
     */
    crpScanPolling(params) {
        axios({
            url: '/publicApi/scanPolling',
            baseURL: BASE_URL,
            method: 'post',
            data: params
        }).then(function (response) {
            actions.dispatcherActions(response.data, '_scanPolling');
        })
    }

    /**
     * 账号密码登录 - crp
     */
    crpPasswordLogin(params) {
        axios({
            url: '/crp/v1/permission/pc/login',
            baseURL: BASE_URL,
            method: 'post',
            data: params
        }).then(function (response) {
            actions.dispatcherActions(response.data, '_passwordLogin');
        }).catch(function () {
            actions.dispatcherActions({ errCode: -1, errMsg: '网络异常，请稍后重试' }, '_passwordLogin');
        })
    }

}

export default new Server()



// WEBPACK FOOTER //
// ./src/applications/server/server.js